export const getUnidadeJurisdicionada = (row) => (
  (row.cliente && (row.cliente.nomeAbrev || row.cliente.nomeAbreviado || row.cliente.nome || row.cliente.razaoSocial)) ||
  row.unidadeJurisdicionada ||
  row.clienteNome ||
  '-'
);

export const getSituacao = (row) => (
  (row.emendaParlamentarSituacao && row.emendaParlamentarSituacao.nome) ||
  row.estagioEmenda ||
  ''
);

export const getValorArrecadado = (row) => (
  row.valorArrecadado !== null && row.valorArrecadado !== undefined ? row.valorArrecadado :
    row.totalArrecadado !== null && row.totalArrecadado !== undefined ? row.totalArrecadado :
      row.arrecadado
);

export const getAcaoGovernamental = (row) => row.acaoGovernamental || null;

export const formatDateBR = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleDateString('pt-BR');
};

export const formatPessoaJuridica = (item) => {
  if (!item) return '';

  const documento = item.cnpj || item.documento;
  const nome = item.nome;
  const esfera = item.esfera;

  const partes = [];
  if (documento) partes.push(documento);
  if (nome) partes.push(nome);
  if (esfera) partes.push(`(${esfera})`);

  return partes.length > 0 ? partes.join(' - ').replace(' - (', ' (') : '';
};
